module.exports = __webpack_public_path__ + "static/img/pingtai.9cdd3b6b.png";